import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from "../locales/en.json";
import ar from "../locales/ar.json";

i18n
    .use(LanguageDetector) 
    .use(initReactI18next) 
    .init({
        debug : true,
        // lng : 'ar',
        fallbackLng: 'ar',
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false, 
        },
        resources: {
            en: {translation: en},
            ar: { translation: ar }
        },
    });

export default i18n;
